module.exports = __webpack_public_path__ + "img/Fast-and-Furious-AR-poster.700b3370.jpg";